import {Events, NavController} from 'ionic-angular';
import {UserData} from '../providers/user-data';
import {AppSettings} from '../config/app-settings';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/toPromise';
import {PageRef} from '../core/page-ref';
import { Angulartics2 } from 'angulartics2';
import { Location } from '@angular/common';
import { StoreLocatorData } from '../modules/store-locator/providers/store-locator-data';

export class PageBase {
	public currentUser: any;
	public currentStore: any;
	public pageRef: PageRef;
	public angulartics: Angulartics2;
	public location: Location;
	public storeLocatorData : StoreLocatorData;

	constructor(
		public settings: AppSettings,
		public events: Events,
		public nav: NavController,
		public userData: UserData
	){
		//let p = ReflectiveInjector.resolveAndCreate([PageRef]);
		//this.pageRef = Injector.get(PageRef);
		//this.pageRef = (<any>window).applicationInjector.get(PageRef); 
		//console.log(this.pageRef);
		var injector =(<any>window).applicationInjector;
		if(!injector){
			return;
		}
		if(!this.pageRef){
			this.pageRef = injector.get(PageRef);
		}
		if(!this.angulartics){
			this.angulartics = injector.get(Angulartics2);
		}
		if(!this.location){
			this.location = injector.get(Location);
		}
		if(!this.storeLocatorData){
			this.storeLocatorData = injector.get(StoreLocatorData);
		}

	}	
	
	public loadCurrentUser(){
		return Observable.create((observer) => {
			this.userData.hasLoggedIn().subscribe((isLoggedIn) => {
				if(isLoggedIn){
					this.userData.getUser().subscribe((user) => {
						this.currentUser = user;
						observer.next(user);
						observer.complete();
					});
				}else{
					observer.next(null);
					observer.complete();
				}
			});	
		});
	}

	public loadCurrentStore(){
		return Observable.create((observer) => {
			this.storeLocatorData.getCurrentStore().subscribe((store) => {
		       this.currentStore = store;
				observer.next(store);
				observer.complete();
			});	
		});
	}


	public goToPage(name){
		this.nav.push(this.pageRef.get(name));
	}

	public ionViewCanEnter(): Promise<boolean>{
		// console.log('can Enter');
		if(this.settings){
			return Observable.from([this.loadCurrentUser(),this.loadCurrentStore()]).combineAll().toPromise().then((user)=>{
				if(this.settings && this.settings.requireLogin && !user){
					this.nav.setRoot(this.pageRef.get('login'));  
					return false;    
				}
				else{
					return true;
				}
			});
		}
		else{
			var src:Promise<boolean> =  this.settings.getData().toPromise();
			return src.then((settings)=>{
				return Observable.from([this.loadCurrentUser(),this.loadCurrentStore()]).combineAll().toPromise().then((user)=>{
					if(this.settings && this.settings.requireLogin && !user){
						this.nav.setRoot(this.pageRef.get('login'));  
						return false;    
					}
					else{
						return true;
					}
				});

			});	
		}
	}
	public ionViewWillEnter():void {
		setTimeout(function(){
			if(this.angulartics && this.location){
				this.angulartics.pageTrack.next({
					path: this.location.path(),
		          	location: /*this.location*/ '',
				});	
			}
		}.bind(this),100);
		
	} 
}


// WEBPACK FOOTER //
// ./src/core/page-base.ts